<template>
  <label :class="`base-input ${name}`"
         :cy="cy || name">
    <span v-if="!noLabel"
          class="label block">
      {{ label || name }}
    </span>

    <textarea v-if="type === 'textarea'"
              @input="handleInput"
              :class="{'text-center': center}"
              :value="value"
              :placeholder="placeholder || label" />

    <input v-else
           :type="type || 'text'"
           :class="{'bottom-border-only': simple, 'text-center': center}"
           :disabled="disabled"
           @input="handleInput"
           :value="value"
           :placeholder="placeholder || label" />
    <span>
      <slot />
    </span>
  </label>
</template>

<script>
  export default {
    name: 'BaseInput',
    props: {
      name: String,
      label: String,
      type: String,
      cy: String,
      value: [String, Number],
      placeholder: String,
      simple: Boolean,
      noLabel: Boolean,
      center: Boolean,
      disabled: Boolean
    },
    methods: {
      handleInput (ev) {
        this.$emit('input', {
          name: this.name,
          value: ev.target.value
        });
      }
    }
  }
</script>

<style lang="less">
  .base-input {
    .label {
      font-size: 1.4rem;
      margin-bottom: 4px;
    }
    input,
    textarea {
      padding-left: 8px;
    }
    input + span,
    textarea + span {
      margin-left: 8px;
      font-size: 1.6rem;
    }
    textarea {
      min-height: 80px;
    }
    .bottom-border-only {
      border: none;
      border-bottom: 1px solid #5e5e5e;
      border-radius: 0;
      background-color: transparent;
    }
  }
</style>
